import { useLocation } from "react-router-dom";
import RetailersView from "./RetailersView";
import { useEffect, useState } from "react";
import GoBackButton from "../../../Component/Common/GoBackButton";
import OprRetailersView from "./RetailersView";

export default function RetailersPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const filterType = params.get("filter");

  // Data passed from dashboard
  const passedRetailers = location.state?.retailers || [];
  const pageTitle = location.state?.title || "Retailers";

  const [retailers, setRetailers] = useState(passedRetailers);
  const [filteredRetailers, setFilteredRetailers] = useState([]);
  const [searchRetailer, setSearchRetailer] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState(null);
  const [selectedRetailerId, setSelectedRetailerId] = useState("");

  useEffect(() => {
    setRetailers(passedRetailers);
    setFilteredRetailers(passedRetailers);
  }, [passedRetailers]);

  useEffect(() => {
    applyFilter();
  }, [filterType, retailers]);

  const applyFilter = () => {
    let filtered = [...retailers];

    switch (filterType) {
      case "connected":
        filtered = retailers.filter(r => r.isConnected);
        break;

      case "using":
        filtered = retailers.filter(r => r.usingProduct);
        break;

      case "sales":
        filtered = [...retailers].sort((a, b) => b.monthSales - a.monthSales);
        break;

      default:
        break;
    }

    setFilteredRetailers(filtered);
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-white border-b px-4 py-3">
        <h1 className="text-lg font-semibold text-slate-800 mt-2">
          {pageTitle}
        </h1>

        <p className="text-xs text-slate-500 hidden md:block">
          Monitor retailers, sales, collections & your own productivity.
        </p>
      </header>

      <div className="p-2">
        <OprRetailersView
          retailers={filteredRetailers}
          allRetailers={retailers}
          searchRetailer={searchRetailer}
          setSearchRetailer={setSearchRetailer}
          selectedRetailer={selectedRetailer}
          setSelectedRetailerId={setSelectedRetailerId}
        />
      </div>
    </div>
  );
}
